module.exports = __webpack_public_path__ + "img/pp-blue.2aa00d8e.png";